import React from 'react';
import './sectionFour.scss';

const SectionFour = () => {
    // Inline SVG for the orange checkmark
    const CheckIcon = () => (
        <svg 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="#FF5A14" 
            strokeWidth="3" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
    );

    const impactData = [
        { id: 1, title: 'ROOT CAUSE', desc: 'Across revenue, margin, inventory and operations' },
        { id: 2, title: 'QUANTIFIED EXPOSURE', desc: 'Revenue, EBITDA, working capital, service' },
        { id: 3, title: 'RECOMMENDED ACTION', desc: 'Intervention, allocation, scenario, trade-off' },
        { id: 4, title: 'ACCOUNTABLE EXECUTION', desc: 'Owner, due date, workflow, escalation' },
        { id: 5, title: 'REALIZED IMPACT', desc: 'Expected vs actual value captured' },
    ];

    return (
        <div id='SectionFour' className='insight-impact-section'>
            <div className='section-container'>
                
                {/* Left Column: Text */}
                <div className='left-column'>
                    <div className='subtitle-wrapper'>
                        <p className='subtitle'>FROM INSIGHT TO IMPACT</p>
                    </div>
                    <h2 className='main-heading'>
                        Turn analysis into <br />
                        <span className='highlight'>measurable outcomes.</span>
                    </h2>
                </div>

                {/* Right Column: List */}
                <div className='right-column'>
                    {impactData.map((item) => (
                        <div className='impact-row' key={item.id}>
                            <div className='row-left'>
                                <CheckIcon />
                                <span className='row-title'>{item.title}</span>
                            </div>
                            <div className='row-right'>
                                <p className='row-desc'>{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default SectionFour;